var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 14.6469V3.91361C16.5002 3.07028 15.8102 2.38028 14.9669 2.38028H4.23353C3.3902 2.38028 2.7002 3.07028 2.7002 3.91361V14.6469C2.7002 15.4903 3.3902 16.1803 4.23353 16.1803H14.9669C15.8102 16.1803 16.5002 15.4903 16.5002 14.6469ZM6.91686 10.4303L8.83353 12.7379L11.5169 9.28028L14.9669 13.8803H4.23353L6.91686 10.4303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4,
    height: 18.4,
    fill: "white",
    transform: "translate(0.400391 0.0802917)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.adff52aa2e91c37dfd3d4994e5f8d066.svg";
export { ForwardRef as ReactComponent };